import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import axios from 'axios';
import 'react-quill/dist/quill.snow.css';
import '../styles/CounselorRegistration.scss';
import { useAuth } from '../context/AuthContext';

const CounselorRegistrationPage: React.FC = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [content, setContent] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFiles(Array.from(e.target.files));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (files.length === 0) {
      alert('자격증 사본 파일을 첨부해주세요.');
      return;
    }
    if (!content.trim()) {
      alert('소개 및 경력 내용을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    
    // FormData creation for file upload
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('qualificationFiles', file);
    });
    formData.append('content', content);
    if (user?.id) {
        formData.append('userId', user.id);
    }

    try {
      await axios.post('/api/users/register-counselor', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('상담사 등록 신청이 완료되었습니다.');
      navigate('/profile');
    } catch (error) {
      console.error('Registration failed:', error);
      alert('등록 신청 중 오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-container counselor-registration-container">
      <div className="page-header">
        <h2 className="page-header__title">상담사 등록 신청</h2>
      </div>

      <div className="guidance-section">
        <h3>자격 요건 안내</h3>
        <div className="guidance-content">
          <p><strong>● 1급 유형</strong></p>
          <p>① (국가전문자격) 「정신건강증진 및 정신질환자 복지서비스 지원에 관한 법률」 제17조에 따른 정신건강전문요원 1급</p>
          <p>② (국가전문자격) 「청소년 기본법」 제22조에 따른 청소년상담사 1급</p>
          <p>③ (국가전문자격) 「사회복지사업법」 제19조의2에 따른 전문상담교사 1급</p>
          <p>④ (민간자격) 보건복지부장관이 인정하는 심리상담분야 전문가로서 상담분야를 전공(심리·상담학과 등)한 석사 또는 박사 학위소지자가 다음 중 하나의 수련요건을 충족하는 경우</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;(가) 박사 취득 후 심리상담 수련시간 총 2,000시간 이상</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;(나) 석사 취득 후 심리상담 수련시간 총 3,000시간 이상</p>
          <p>⇒ ‘24년~’25년 사업 참여 민간자격 : 임상심리전문가(한국심리학회), 상담심리사 1급(한국상담심리학회/한국심리학회), 전문상담사 1급(한국상담학회)</p>
          <br />
          <p><strong>● 2급 유형</strong></p>
          <p>① (국가전문자격) 「정신건강증진 및 정신질환자 복지서비스 지원에 관한 법률」 제17조에 따른 정신건강전문요원 2급</p>
          <p>② (국가전문자격) 「청소년 기본법」 제22조에 따른 청소년상담사 2급</p>
          <p>③ (국가전문자격) 「사회복지사업법」 제19조의2에 따른 전문상담교사 2급</p>
          <p>④ (국가기술자격) 「국가기술자격법」 제8조의2에 따른 임상심리사 1급</p>
          <p>⑤ (민간자격) 보건복지부장관이 인정하는 심리상담분야 전문가로서 상담분야를 전공(심리·상담학과 등)한 학사 또는 석사 학위소지자가 최소 1,000시간 이상 심리상담 수련시간을 충족하는 경우</p>
          <p>⇒ ‘24년~’25년 사업 참여 민간자격 : 상담심리사 2급(한국상담심리학회/한국심리학회), 전문상담사 2급(한국상담학회)</p>
        </div>
      </div>

      <form className="registration-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="qualificationFile">자격증 사본 첨부 (여러 개 선택 가능)</label>
          <input
            type="file"
            id="qualificationFile"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            multiple
            required
          />
          {files.length > 0 && (
            <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
              선택된 파일: {files.map(f => f.name).join(', ')}
            </div>
          )}
        </div>

        <div className="form-group">
          <label>소개 및 경력 기술</label>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            placeholder="자격증 관련 상세 경력 및 자기소개를 입력해주세요."
          />
        </div>

        <div className="form-actions">
          <button type="button" className="cancel-btn" onClick={() => navigate('/profile')}>
            취소
          </button>
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? '제출 중...' : '등록 신청'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CounselorRegistrationPage;
